import React from "react"
import { useSelector } from "react-redux"
import { Redirect } from "react-router-dom"
import { getConsumerSubscription } from "#/redux/reducers/userInfo"
import { useConsumerRoutesEnabled } from "#/services/launchdarkly/useConsumerRoutesEnabled"
import {
  CONSUMER_REGISTRATION_RESUME_PATH,
  shouldResumeExternalRegistration
} from "#/services/consumerSubscription/externalStorefront"
import { LoadingInner } from "./Loading"

// A restored session or SAML relaunch can belong to an external-storefront member who hasn't finished
// registering. Holds the app back until this session's users/me (the bootstrap's own read) answers, so they
// never see the app or the paywall first. A users/me failure falls through to the app, which reports it.
export function ExternalRegistrationGuard({ children }: { children: React.ReactElement }): React.ReactElement {
  const consumerRoutesEnabled = useConsumerRoutesEnabled()
  const consumerSubscription = useSelector(getConsumerSubscription)

  if (!consumerSubscription.loaded) {
    return <LoadingInner />
  }
  if (consumerRoutesEnabled && shouldResumeExternalRegistration(consumerSubscription.value)) {
    return <Redirect to={CONSUMER_REGISTRATION_RESUME_PATH} />
  }
  return children
}
